import { BackgroundColor } from '@ampcore/ampcom-contracts'
import { pascalCase } from '@ampcore/string-format'
import React from 'react'

import { Image, ImageProps } from '../Image/Image'

export type FacetImageProps = ImageProps & {
  color: BackgroundColor
}

export function FacetImage({
  color,
  className,
  ...imageProps
}: FacetImageProps) {
  return (
    <Image
      className={`FacetImage u-bgColor${pascalCase(color)} ${className}`}
      {...imageProps}
    />
  )
}
